import {Injectable} from '@angular/core';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
import {BackendServiceResponse} from '../../model/backend-service-response';
import {User} from '../../model/user';
import {MasbitHttpService} from '../../common/http/masbit-http.service';

@Injectable()
export class UserSettingsService {
  static readonly USER_UPDATE_SERVICE_URL = environment.apiUrl.concat(environment.userUpdateServiceUrl);


  constructor(private httpClient : MasbitHttpService) { }

  userUpdate(params : any) : Observable<BackendServiceResponse<number, User>> {
    return this.httpClient.post<BackendServiceResponse<number, User>>(UserSettingsService.USER_UPDATE_SERVICE_URL, params);
  }

}
